<template>
  <v-row
    style="margin: 0; width: 100%;"
  >
    <v-col
      :cols="$vuetify.breakpoint.mobile ? 12 : undefined"
    >
      <text-field
        v-model="formDataCopy.related_document"
        :field="{
          key: 'related_document',
          label: $t('road-maintenance/aggregator.related_document'),
          editable: false
        }"
        :validation-errors="validationErrors"
        disabled
        @clear-validation-errors="$emit('clear-validation-errors', 'related_document')"
      />
    </v-col>

    <v-col
      :cols="$vuetify.breakpoint.mobile ? 12 : undefined"
    >
      <text-field
        v-model="formDataCopy.erp_reference_number"
        :field="{
          key: 'erp_reference_number',
          label: $t('road-maintenance/aggregator.related_document_number')
        }"
        :validation-errors="validationErrors"
        @clear-validation-errors="$emit('clear-validation-errors', 'erp_reference_number')"
      />
    </v-col>

    <v-col
      style="display: flex; flex-direction: row;"
      :style="{ flexDirection: $vuetify.breakpoint.mobile ? 'column' : undefined }"
      :cols="$vuetify.breakpoint.mobile ? 12 : undefined"
    >
      <text-field
        v-model="formDataCopy.erp_document_status"
        :field="{
          key: 'erp_document_status',
          label: $t('road-maintenance/aggregator.related_document_status'),
          style: {
            backgroundColor: '#F0FDF4 !important',
            border: '1px solid #86EFAC !important',
            borderRadius: '8px !important',
            marginRight: !$vuetify.breakpoint.mobile ? '3%' : '0',
            marginBottom: $vuetify.breakpoint.mobile ? '3%' : '0'
          },
          labelStyle: {
            width: 'max-content'
          },
          editable: false
        }"
        disabled
        :validation-errors="validationErrors"
        @clear-validation-errors="$emit('clear-validation-errors', 'erp_document_status')"
      />

      <universal-button
        :label="$t('road-maintenance/aggregator.retrieve_accounting_status')"
        color="#65AD45"
        style="height: 40px !important; align-self: end;"
        :style="{ width: $vuetify.breakpoint.mobile ? '100%' : 'auto' }"
        @click="onFetchAccountingStatus"
      />
    </v-col>
  </v-row>
</template>

<script>
import { isObject } from 'lodash'
import TextField from '@/global/components/view-layouts/tabs-layout/components/fields/TextField.vue'
import UniversalButton from '@/global/components/buttons/UniversalButton.vue'

export default {
  name: 'AccountingFieldsRow',

  components: {
    UniversalButton,
    TextField
  },

  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      formDataCopy: {}
    }
  },

  watch: {
    formData: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val && isObject(val)) {
          this.formDataCopy = val
        }
      }
    }
  },

  methods: {
    onFetchAccountingStatus () {
    }
  }
}
</script>

<style scoped>
</style>
